import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { CfetBaseComponent } from '../../../cfet-core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
    selector: 'app-dont-see-your-workplace-form',
    templateUrl: './dont-see-your-workplace-form.component.html',
    styleUrls: ['./dont-see-your-workplace-form.component.scss'],
    standalone: false
})
export class DontSeeYourWorkplaceFormComponent extends CfetBaseComponent implements OnInit {

  dontSeeYourWorkplaceFormGroup: UntypedFormGroup;
  nameValue: UntypedFormControl;
  address1Value: UntypedFormControl;
  address2Value: UntypedFormControl;
  cityValue: UntypedFormControl;
  stateValue: UntypedFormControl;
  zipCode: UntypedFormControl;
  stateValueOption: any;
  stateList: any[] = [];
  selectedName: any;
  selectedAddress1: any;
  selectedAddress2: any;
  selectedCity: any;
  selectedState: any;
  selectedZip: any;
  zipcodeError: boolean;
  isValidName = true;
  isValidAddress1: boolean;
  cityError: boolean;
  disabledSubmitButton = true;
  showEnterWorkplaceFormManuallySection = true;
  showEligibilityCompletion = false;
  checkState = '';
  checkstateAndZip = { 'org_name': '' };
  stateData: Array<any> = [];
  spaTerritories: Array<any> = [];
  @Output() manualeligibilitycompletionstatus = new EventEmitter<any>();
  @Output() showSelectedStateZipAndSearchSection = new EventEmitter<any>();
  @Output() manualValues = new EventEmitter<any>();
  @Output() stateAndZipPresent = new EventEmitter<any>();
  @Output() showCancelModal = new EventEmitter<any>();

  constructor(private router: Router) { super(); }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.nameValue = new UntypedFormControl('', [Validators.required]);
    this.address1Value = new UntypedFormControl('', [Validators.required]);
    this.address2Value = new UntypedFormControl('', [Validators.required]);
    this.stateValue = new UntypedFormControl('', [Validators.required]);
    this.cityValue = new UntypedFormControl('');
    this.zipCode = new UntypedFormControl('', { validators: [Validators.required, Validators.minLength(5)], updateOn: 'change' });
    this.stateValueOption = { 'value': 'Select', 'text': 'Select' };
    this.stateList = [];
    this.dontSeeYourWorkplaceFormGroup = new UntypedFormGroup({
      nameValue: this.nameValue,
      address1Value: this.address1Value,
      address2Value: this.address2Value,
      zipCode: this.zipCode,
      cityValue: this.cityValue,
      stateValue: this.stateValue
    });
    //getting commonListValues
    const commonListValues = JSON.parse(sessionStorage.getItem('ngStorage-commonListValues'));
    this.stateData = commonListValues['validStates'];
    this.spaTerritories = commonListValues['validSPATerritories'];
    this.setStateDataUsingTerritories();
    this.stateData.sort();
    //setting the Statevalues
    if (this.stateData && this.stateData.length > 0) {
      this.stateList = this.stateData.map(
        stateValue => {
          return { value: stateValue, text: stateValue.split(':')[1] };
        }
      );
    }
  }

  onValueChanges() {
    this.dontSeeYourWorkplaceFormGroup.valueChanges.subscribe(val => {
      if (val.nameValue !== '' && val.address1Value !== '' && val.cityValue.length > 1
        && (val.stateValue !== '' && val.stateValue !== 'Select')
        && (val.zipCode !== '' && val.zipCode.replace(/[^0-9\-]/g, '').length > 4)) {
        this.disabledSubmitButton = false;
      } else {
        this.disabledSubmitButton = true;
      }
    });
  }

  setStateDataUsingTerritories() {
    Object.keys(this.spaTerritories).forEach((key) => {
      let val = this.spaTerritories[key];
      this.stateData = this.stateData.concat(val);
    });
  }

  checkName() {
    const regexpName = new RegExp(/^([a-z0-9A-Z_!#^$%*)(+&@'\- ]{2,})$/);
    this.isValidName = regexpName.test(this.nameValue.value);
  }

  checkAddress1() {
    this.isValidAddress1 = this.address1Value.value.length > 1 ? false : true;
  }

  checkCity() {
    this.cityError = this.cityValue.value.length > 1 ? false : true;
  }

  changeZip() {
    this.zipCode.setValue(this.zipCode.value.replace(/[^0-9\-]/g, ''));
    this.onValueChanges();
    this.checkZip();
  }

  onClickState(event) {
    if (event.target.ariaExpanded === 'true') {
      this.checkState = 'dropdown-opened';
    } else {
      this.checkState = '';
    }
  }

  onChangeStateOption(event) {
    this.checkState = '';
    this.stateValue.setValue(event.value);
    this.onValueChanges();
  }

  checkZip() {
    this.zipcodeError = this.zipCode.value.length < 5 ? true : false;
  }

  submit(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showEnterWorkplaceFormManuallySection = false;
      this.showEligibilityCompletion = true;
      this.selectedName = this.nameValue.value;
      this.selectedAddress1 = this.address1Value.value;
      this.selectedAddress2 = this.address2Value.value;
      this.selectedState = this.stateValue.value;
      this.selectedCity = this.cityValue.value;
      this.selectedZip = this.zipCode.value.replace(/[^0-9\-]/g, '');
      this.manualValues.emit(true);
      this.checkstateAndZip['org_name'] = this.nameValue.value;
      this.checkstateAndZip['address'] = this.address1Value.value;
      this.checkstateAndZip['city'] = this.cityValue.value;
      this.checkstateAndZip['state'] = this.stateValue.value;
      this.checkstateAndZip['zipcode'] = this.zipCode.value.replace(/[^0-9\-]/g, '');
      this.stateAndZipPresent.emit(this.checkstateAndZip);
      const workPlaceInfo = {
        completionStatus: true,
        selectedName: this.selectedName,
        selectedAddress: this.selectedAddress2 ? this.selectedAddress1 + ',' + this.selectedAddress2 : this.selectedAddress1,
        selectedCity: this.selectedCity,
        selectedStateInWorkplace: this.selectedState,
        selectedZipInWorkplace: this.selectedZip.replace(/[^0-9\-]/g, '')
      };
      this.manualeligibilitycompletionstatus.emit(workPlaceInfo);
    }
  }

  cancelCreation(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showCancelModal.emit(true);
    }
  }

  editWorkplace(event) {
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      this.showSelectedStateZipAndSearchSection.emit(true);
      this.showEligibilityCompletion = false;
    }
  }
}
